<button mat-mini-fab #iconButton (click)="click($event)"
        [color]="colour"
        [id]="id"
        [permission-lock]="permissions"
        [disabled]="!preconditions || disabled"
        type="button">
  <mat-icon [fontSet]="fontSet" [fontIcon]="icon" [ngClass]="iconClass" aria-hidden="true"></mat-icon>
</button>
